import React, { forwardRef } from "react";
import { Box as ChakraBox } from "@chakra-ui/react";
/**
 * Box should be mostly used for quickly stylable layout elements.
 * And as building blocks for new components.
 * It is build on top of [styled-system](https://styled-system.com/table/) for easy styling and
 * can use the **as** prop to render as any HTML element.
 */
const Box = forwardRef((props, ref) => {
    return React.createElement(ChakraBox, Object.assign({ ref: ref }, props));
});
Box.displayName = "Box";
export default Box;
//# sourceMappingURL=Box.js.map